import { createReducer, on } from '@ngrx/store';
import * as SidebarActions from './sidebar.actions';

export type SidebarMode = 'expanded' | 'collapsed' | 'hidden';

export interface SidebarState {
   /**
    * Canonical sidebar state
    */
   mode: SidebarMode;

   /**
    * Backward compatibility flag
    * DO NOT remove until all consumers migrate
    */
   isExpanded: boolean;
}

/**
 * IMPORTANT:
 * - No window
 * - No localStorage
 * - No breakpoint logic
 * - Deterministic initial state (SSR-safe)
 */
export const initialState: SidebarState = {
   mode: 'collapsed',
   isExpanded: false
};

export const sidebarReducer = createReducer(
   initialState,

   /** Toggle only makes sense when sidebar is visible */
   on(SidebarActions.toggleSidebar, (state) => {
      if (state.mode === 'hidden') {
         return {
            ...state,
            mode: 'expanded' as SidebarMode,
            isExpanded: true
         };
      }

      const nextMode: SidebarMode =
         state.mode === 'expanded' ? 'collapsed' : 'expanded';

      return {
         ...state,
         mode: nextMode,
         isExpanded: nextMode === 'expanded'
      };
   }),

   on(SidebarActions.expandSidebar, (state) => ({
      ...state,
      mode: 'expanded' as SidebarMode,
      isExpanded: true
   })),

   on(SidebarActions.collapseSidebar, (state) => ({
      ...state,
      mode: 'collapsed' as SidebarMode,
      isExpanded: false
   })),

   on(SidebarActions.hideSidebar, (state) => ({
      ...state,
      mode: 'hidden' as SidebarMode,
      isExpanded: false
   })),

   // on(SidebarActions.showSidebar, (state) => ({
   //    ...state,
   //    mode: state.mode === 'hidden' ? 'expanded' : state.mode,
   //    isExpanded: state.mode === 'expanded'
   // })),

   on(SidebarActions.restoreSidebarVisibility, (state) => {
      const nextMode = (state.mode === 'hidden' ? 'expanded' : state.mode) as SidebarMode;
      return {
         ...state,
         mode: nextMode,
         isExpanded: nextMode === 'expanded'
      };
   })
);
